import { fetchCompanyUsers } from 'common/api/financierInstallers';

import {
    FETCH_COMPANY_USERS,
    FETCH_CONPANY_USERS_FAILURE,
    FETCH_COMPANY_USERS_SUCCESS,
} from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (id) => (dispatch) => {
    dispatch(installerProfileActions[FETCH_COMPANY_USERS]());

    fetchCompanyUsers(id)
        .then((response) =>
            dispatch(
                installerProfileActions[FETCH_COMPANY_USERS_SUCCESS](
                    response.data.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                installerProfileActions[FETCH_CONPANY_USERS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
